import { RtkqSpin } from '@app/base';
import { Role, UserLookup, useLazyGetEmployeeLookupsQuery } from '@app/main/api';
import { EMPTY_OPTION_SOURCE, Option, OptionSource, createEntireLoadOptionSource } from '@webinex/antik';
import { Typography } from 'antd';
import { orderBy } from 'lodash';
import { useMemo } from 'react';
import { formatters } from '@app/ui';
import { Name } from '../components';

export function mapEmployeeOption(value: UserLookup): Option {
  return {
    label: (
      <div>
        <div>
          <Name value={value} />
        </div>
        <div className="ant-selected-none">
          <Typography.Text type="secondary">{value.email}</Typography.Text>
        </div>
      </div>
    ),
    value: value.id,
    _searchValue: `${value.firstName} ${value.lastName} ${value.email}`,
  };
}

export function useEmployeeOptionSource(args?: {
  role?: Role;
  skip?: boolean;
  onlyActive?: boolean;
}): OptionSource {
  const { role, skip, onlyActive } = args ?? {};
  const [fetchList, { currentData }] = useLazyGetEmployeeLookupsQuery();

  return useMemo(() => {
    if (skip) {
      return EMPTY_OPTION_SOURCE;
    }
    return createEntireLoadOptionSource({
      fn: () =>
        fetchList({ [RtkqSpin]: false, role, onlyActive }, true)
          .unwrap()
          .then((values) => orderBy(values, (x) => [!x.active, formatters.name(x)]).map(mapEmployeeOption)),
      searchBy: '_searchValue',
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchList, currentData, role]);
}
